export default __webpack_public_path__ + "static/media/web.9dcbe26b.svg";